// Will be the intermediary between the central image manager modal and the toggler
// Will hold the config passed from toggler and send it to the central image manager modal
import { create } from "zustand";

const defaultConfig = {
  contextKey: "default",
  allowDuplicates: false,
  maxSelect: 1,
  value: [],
  onSelect: () => {},
};

export const useImageManagerUI = create((set) => ({
    // Track if modal is currently open
    isOpen: false,
    config: { ...defaultConfig },
   
    // Opens the modal with a given config
    openImageManager: (config) =>
      set(() => ({
        isOpen: true,
        config: {
          ...defaultConfig,
          ...config,
          onSelect: config?.onSelect ?? (() => {}),
        },
      })),


    // Closes the modal and resets critical callback to avoid memory leaks
    closeImageManager: () =>
      set(() => ({
        isOpen: false,
        config: { ...defaultConfig },
      })),

    resetConfig: () =>
      set(() => ({
        config: { ...defaultConfig },
      })),

}));